import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackAddressCreatedParameters extends TrackEventBaseParameters {}

const trackAddressCreated = (parameters: TrackAddressCreatedParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "address_created", ...parameters }, options);
};

export default trackAddressCreated;
